import React, { Component } from 'react';

class Weather extends Component {
  constructor(props) {
	  super(props);
	  this.state = {
        temperature : '',
		weather : '',
		iconURL : ''
	  };
	}
	componentDidMount() {
	fetch("https://api.openweathermap.org/data/2.5/weather?q=Helsinki,fi&appid=84a200e8b37f69c3b4f5de796981c911&units=metric")
		.then((response) => response.json())
		.then((responseData) => {
			var temperature = responseData.main.temp;
			var weather = responseData.weather[0].main;
			var icon = responseData.weather[0].icon;
			this.setState({
				temperature: temperature,
				weather: weather,
				iconURL: "https://api.openweathermap.org/img/w/" + icon + ".png"
			});
		});
	}
  render() {
    return (
	<div class="w3-container w3-padding-large">
        <h2>Weather in Helsinki</h2>
        <div class="w3-row" style={{"max-width":640}}>
            <div class="w3-half w3-container">
                <p>Temperature: {this.state.temperature} celsius</p>
                <p>Weather: {this.state.weather}</p>
            </div>
            <div class="w3-half w3-container">
                <img src={this.state.iconURL} alt="temperature" style={{"width":"100%","max-width":80}}></img>
            </div>
		</div>
	</div>
    );
  }
}

export default Weather;



// WEBPACK FOOTER //
// ./src/Weather.js